import Vue     from 'vue';
// import Vuetify from 'vuetify/lib';
// commented the line above for faster build, if there is a problem then uncomment line above and comment the below line
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
});